import React, {useCallback, useEffect, useState} from 'react';
import { Dropdown } from 'react-bootstrap';

import ProjectItem from '../project-item';
import '../../../scss/components/form.scss'
import Button from '../../../components/button';
import config from "../../../config";

function Project() {
    const [data, dataSet] = useState([])
    const [visible , setVisible] = useState(null);


    const fetchMyAPI = useCallback(async (_next) => {
        let cursor = '';
        if (_next) {
            cursor = `&cursor=${_next}`;
        }
        let response = await fetch(`https://api.opensea.io/api/v1/assets?asset_contract_address=${config.contract_address}${cursor}&format=json`)
        response = await response.json()
        dataSet(d =>d.concat(response['assets']));
        setVisible(response['next'])
    }, [])

    useEffect(() => {
        fetchMyAPI(null)
    }, [fetchMyAPI])

    const showMoreItems = async () => {
        await fetchMyAPI(visible);
    }

    return (
        <section className="tf-section tf-project home-2 nft-item">
            <div className="container">
                <div className="row">
                    <div className="col-md-4 d-none">
                        <div className="widget widget-search" data-aos="fade-in" data-aos-duration="800">
                            <form action="#">
                                <input type="text" placeholder="Search" required="" />
                                <button><i className="fal fa-search"></i></button>
                            </form>
                        </div>
                    </div>

                    <div className="col-md-8 z-index d-none">
                        <div className="seclect-box" data-aos="fade-in" data-aos-duration="800">
                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-basic">
                                    All Categories
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                <Dropdown.Item href="#">
                                    <li data-toggle="modal" data-target="#delete_client">Forgotten Samurai</li>
                                </Dropdown.Item>
                                <Dropdown.Item href="#">
                                    <li data-toggle="modal" data-target="#edit_client">Star Batter</li>
                                </Dropdown.Item>
                                <Dropdown.Item href="#">
                                    <li data-toggle="modal" data-target="#edit_client">Calvary Deneral</li>
                                </Dropdown.Item>

                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-basic">
                                Default sorting
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                <Dropdown.Item href="#">
                                    <li data-toggle="modal" data-target="#delete_client">Sort by Popularity</li>
                                </Dropdown.Item>
                                <Dropdown.Item href="#">
                                    <li data-toggle="modal" data-target="#edit_client">Sort by Latest</li>
                                </Dropdown.Item>
                                <Dropdown.Item href="#">
                                    <li data-toggle="modal" data-target="#edit_client">Sort by View</li>
                                </Dropdown.Item>

                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>

                    {
                        data.map(item => (
                            <div key={item.id} className="col-md-3">
                                <ProjectItem item={item} />
                            </div>
                        ))
                    }
                    {
                        visible &&
                        <div className="col-md-12">
                            <div className="btn-about center m-t16" data-aos="fade-up" data-aos-delay="300" data-aos-duration="800">
                                <Button title='Load More' path='#' onClick={showMoreItems} />
                            </div>
                        </div>
                    }
                    
                </div>
            </div>
        </section>
    );
}

export default Project;